export enum ChatEventType {
  CHAT_MESSAGE = 'chat_message',
  UNBAN_USER = 'unban_user',
  BAN_USER = 'ban_user',
  CHANGE_SCHEDULE = 'change_schedule',
}
